var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.3 48.1",
    style: {
      enableBackground: "new 0 0 41.3 48.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,32.6c0,1.5-0.4,3.1-1.1,4.8c-0.7,1.7-1.9,3.4-3.4,5.1c-1.6,1.7-3.6,3-6,4s-5.3,1.6-8.5,1.6 c-2.4,0-4.7-0.2-6.7-0.7s-3.8-1.2-5.5-2.2c-1.6-1-3.1-2.3-4.5-3.9c-1.2-1.5-2.3-3.1-3.1-4.9S1,32.7,0.6,30.6c-0.4-2-0.6-4.2-0.6-6.5 c0-3.7,0.5-7.1,1.6-10c1.1-3,2.6-5.5,4.7-7.6c2-2.1,4.4-3.7,7.1-4.8C16.1,0.5,19,0,22,0c3.8,0,7.1,0.7,10,2.2s5.2,3.4,6.7,5.6 c1.6,2.2,2.3,4.3,2.3,6.3c0,1.1-0.4,2-1.1,2.9c-0.8,0.8-1.7,1.2-2.8,1.2c-1.2,0-2.1-0.3-2.7-0.9c-0.6-0.6-1.3-1.6-2-2.9 c-1.2-2.3-2.7-4-4.3-5.2c-1.7-1.1-3.7-1.7-6.1-1.7c-3.9,0-6.9,1.5-9.2,4.4S9.4,19,9.4,24.4c0,3.6,0.5,6.6,1.5,9s2.4,4.2,4.3,5.4 c1.9,1.2,4,1.8,6.5,1.8c2.7,0,5-0.7,6.9-2s3.3-3.3,4.2-5.9c0.4-1.2,0.9-2.2,1.5-3s1.5-1.2,2.9-1.2c1.1,0,2.1,0.4,2.9,1.2 C40.9,30.4,41.3,31.4,41.3,32.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.ff3f7e7e80a2b30f7c01c1f47ae1cd83.svg";
export { ForwardRef as ReactComponent };